import { Pipe, PipeTransform } from '@angular/core';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { transformText } from '../utils/cross-functions';

@Pipe({
  name: 'translate',
  standalone: false,
})
export class TranslatePipe implements PipeTransform {
  transform(text: string, hospitalNames: HospitalNames, isNurse?: boolean): string {
    return transformText(text, hospitalNames, isNurse);
  }
}
